import { useState } from 'react'
import map from 'lodash/map'
import { Dropdown } from 'react-bootstrap'
import type { FormikProps } from 'formik'
import type { SelectOption } from '@ztechapps/webui.input'
import { Field, FormModal } from '@ztechapps/webui.form'
import { Alert } from '@ztechapps/webui.util'
import { AssigneeSelect } from '../Conversation/AssigneeSelect'
import { useConversationInboxContext } from './Context'
import { useConversationBatchActions } from './useConversationBatchActions'

type BatchAssignFormValues = { assigneeId?: string }
const initialValues: BatchAssignFormValues = { assigneeId: undefined }

export const BatchAssignModal = () => {
  const { chatListWithSelection } = useConversationInboxContext()
  const { selectedList } = chatListWithSelection
  const { assignConversations } = useConversationBatchActions()
  const [selectedAssignee, setSelectedAssignee] = useState<SelectOption>()

  const onSubmit = async (values: BatchAssignFormValues) => {
    await assignConversations(map(selectedList, '_id'), values.assigneeId)
    setSelectedAssignee(undefined)
  }

  return (
    <FormModal<BatchAssignFormValues>
      trigger={({ onClick }) => <Dropdown.Item onClick={onClick}>Assign</Dropdown.Item>}
      initialValues={initialValues}
      onSubmit={onSubmit}
      title="Assign conversations"
      saveText="Assign"
      saveCancelButtonsProps={{ saveTitle: 'Assign conversations', cancelTitle: 'Cancel without assigning' }}
    >
      <Field
        name="assigneeId"
        label="Assignee"
        component={AssigneeSelect}
        isClearable
        value={selectedAssignee}
        help="Unassigned — clears the assignee on every selected conversation"
        showHelpAsInline
        onChange={(option: SelectOption, _meta: unknown, fieldProps: { form: FormikProps<BatchAssignFormValues> }) => {
          setSelectedAssignee(option)
          fieldProps.form.setFieldValue('assigneeId', option?._id ?? undefined)
        }}
      />
      <Alert type="info">
        Applies to <b>{selectedList.length}</b> selected conversation(s).
      </Alert>
    </FormModal>
  )
}
